import React from 'react';
import './spinner.scss';

const Spinner = () => (
		<div className="component spinner">
			<div>
				<div className="spinner-container">
					<div className="spinner-rotator">
						<div className="spinner-left">
							<div className="spinner-circle"></div>
						</div>
						<div className="spinner-right">
							<div className="spinner-circle"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
)

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/spinner/spinner.jsx